import { Component, Input, OnInit } from '@angular/core';
import { CommonService } from '../../../services/common.service';

import { DefaultLayoutAlignDirective } from '../../../flex-layout/custom-layout-align';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { FormsModule } from '@angular/forms';
import { DefaultLayoutDirective } from '../../../flex-layout/custom-layout';
import { DefaultLayoutGapDirective } from '../../../flex-layout/custom-layout-gap';
import { ContentAnimDirective } from '../../../theme/product-layout/content-anim.directive';
import { DefaultFlexDirective } from '../../../flex-layout/flex';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'calsoft-plan-compare-type2',
    templateUrl: './plan-compare-type2.component.html',
    styleUrls: ['./plan-compare-type2.component.scss'],
    imports: [DefaultLayoutAlignDirective, MatSlideToggle, FormsModule, DefaultLayoutDirective, DefaultLayoutGapDirective, ContentAnimDirective, DefaultFlexDirective, MatButton, MatIcon]
})
export class PlanCompareType2Component implements OnInit{
  isChecked: boolean = false;
  pricedetail: any;

  toggleChanged() {
    console.log('Slide toggle changed. New value:', this.isChecked);
  }

  @Input() item: any;
  @Input() data: any;

  constructor( private commonService: CommonService,) {

  }
  
  ngOnInit() {   
    this.pricedetail = JSON.parse(this.item.customField31);
  }      

  openInNewWindow(url: string) {
    if (url) {
      this.commonService.goToLink(url)
    }
  }

  prependProtocol(url: string): string {
    if (!url.includes('http://') && !url.includes('https://')) {
      return 'https://' + url;
    }
    return url;
  }

  active: string|any;
scrollDown(value:any){
  this.active =value;
  this.ScrollIntoView(this.active);
}

ScrollIntoView(elem: string) {
  this.active = "#" + elem;
  const ele = document.querySelector(this.active) as HTMLElement;
  
  if (ele) {
    const offsetTop = ele.getBoundingClientRect().top + window.pageYOffset;
    const paddingTop = 96;
    window.scrollTo({
    top: offsetTop - paddingTop,
    behavior: 'smooth'
    });
  } else {
    console.error('Element not found:', this.active);
  }
  }


}
